// @flow
import styled, { css } from "styled-components";
import { SmartLink } from "./SmartLink/SmartLink";
import { media } from "../media";

const invertedColours = css`
  background-color: ${({ theme }) => theme.palette.navy.medium};
  color: ${({ theme, colour }) => theme.palette[colour].medium};
`;

const colours = css`
  color: ${({
    theme,
    colour,
    shade,
    backgroundColour = "white",
    backgroundShade = "light",
  }) =>
    colour === "navy" || shade === "ui"
      ? theme.palette[backgroundColour][backgroundShade]
      : theme.palette.navy.medium};
  background-color: ${({ theme, colour, shade = "medium" }) =>
    theme.palette[colour][shade]};
`;

export const Button = styled.button`
  ${({ inverted }) => (inverted ? invertedColours : colours)};
  padding: 15px 40px;
  font-weight: ${({ theme }) => theme.typography.bold};
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 2px 4px 0 rgba(34, 34, 34, 0.1);
  border-radius: 4px;
  display: inline-block;
  width: 100%;
  font-size: 14px;
  border: none;
  line-height: 1.3;
  text-align: center;
  cursor: pointer;
  ${media.tablet`
    width: ${({ fullWidth }) => (fullWidth ? "100%" : "auto")};
  `};

  transition: all 0.2s ease;
  text-decoration: none;

  &:hover :not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 3px 8px 0 rgba(34, 34, 34, 0.1);
  }

  &:active :not(:disabled) {
    box-shadow: 0 1px 4px 0 rgba(34, 34, 34, 0.1);
    transition: all 0.1s ease;
    transform: translateY(1px);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.3;
  }

  ${({ noBackground }) =>
    noBackground &&
    css`
      background-color: transparent;
      border: none;
      box-shadow: none;
      opacity: 0.6;
    `}
`;

export const ButtonGroup = styled.div`
  display: inline-flex;
  flex-direction: column;
  ${media.tablet`
    flex-direction: row;
  `};

  * {
    flex-shrink: 1;
    margin: 10px;
  }
`;

const LinkStyle = styled(Button)`
  width: ${({ fullWidth }) => (fullWidth ? "100%" : "auto")};
`;

type LinkProps = React$ElementProps<"a">;

export const Link = (props: LinkProps) => (
  <LinkStyle {...props} as={SmartLink} />
);
